import React, { Component } from 'react';
import FancyInput from "../../elements/FancyInput";
import { findDOMNode } from "react-dom";
import axios from "axios/index";
import animations from "./animations";
import globals from "../../globals";
import HoneyPot from "../../elements/HoneyPot";
import Button from "../../elements/Button";
import Heading from "../../elements/Heading";
import FancyToggle from "../../elements/FancyToggle";
import FancySelect from "../../elements/FancySelect/FancySelect";
import Errors from "../../elements/Errors";
import Loader from "../../elements/Loader";
import Success from "../../elements/Success";

class PartnersForm extends Component {

    constructor(props) {
        super(props);

        this.honeypot = 'dob';

        this.state = {
            first_name: '',
            last_name: '',
            mobile: '',
            company: '',
            email: '',
            phone: '',
            abn: '',
            gst_registered: 'no',
            interested_in: '',
            [this.honeypot]: '', //honeypot
            errors: [],
			animateSuccess: false
        };
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.reset();
        animations.scrollUp();
        animations.showLoader(this);

        setTimeout(() => {
            axios.post('/api/submit-partners-form', this.state)
                .then(() => {
                    globals.pushEvent('partnerFormSubmit');
                    this.showSuccess();
                })
                .catch(response => {
                    this.reset();
                    if (response.response.status === 422) {
                        this.processValidation(response.response);
                    } else {
                        this.handleError(response);
                    }
                });
        }, 2000);
    }

    setGstValue(value) {
        this.setState({
            'gst_registered': value
        });
    }

    setInterestedValue(value) {
        this.setState({
            'interested_in': value
        });
    }

    showSuccess() {
		this.setState({
			animateSuccess: true
		}, () => {
			animations.hideLoader(this);
		});
	}

    processValidation(response) {
        let PartnersFormNode = findDOMNode(this),
            errors = response.data.errors;

        for (let key in errors) {
            if (key === this.honeypot) {
                // do nothing
            } else if (key === 'gst_registered') {
                PartnersFormNode.querySelector('.toggle').style.borderColor = 'red';
            } else if (key === 'interested_in') {
                PartnersFormNode.querySelector('.fancy-select .label').style.borderColor = 'red';
            } else {
                PartnersFormNode.querySelector('.input-' + key + ' .graphic--nao').style.stroke = 'red';
            }

            this.updateErrors(errors[key][0]);
        }

        animations.showErrors(this);
    }

    updateErrors(newError) {
        this.setState(prevState => ({
            errors: [...prevState.errors, newError]
        }));
    }

    handleError(response) {
        this.updateErrors(globals.getGenericErrorMsg());
        animations.showErrors(this);
        globals.handleError(response.message, response);
    }

    reset() {
        this.setState({
            errors: []
        });
        animations.reset(this);
    }

    render() {
        return (
            <div className="partners-form white-bg-form">
                <div id="partners-anchor" />
                <Heading title="Become an Exetel partner" subTitle="Fill in the form below and we will get back to you real quick" />
                <div className="row form-outer">
                    <div className="col-md-8 col-md-offset-2 col-xs-12">
                        <form onSubmit={this.handleSubmit.bind(this)}>

                            <div className="row form-row">
                                <div className="col-sm-6 name-fields">
                                    <FancyInput name="first_name" maxLength="50" label="First Name" value={this.state.first_name} handleChange={this.handleInputChange.bind(this)} />
                                    <FancyInput name="last_name" maxLength="50" label="Last Name" value={this.state.last_name} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-6">
                                    <FancyInput name="email" type="email" maxLength="50" label="Email" value={this.state.email} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                            </div>
                            <HoneyPot nameField={this.honeypot} nameValue={this.state[this.honeypot]} handleChange={this.handleInputChange.bind(this)} />
                            <div className="row form-row">
                                <div className="col-sm-6">
                                    <FancyInput name="phone" type="tel" maxLength="20" label="Phone Number" value={this.state.phone} handleChange={this.handleInputChange.bind(this)} />
                                    <small>Phone or mobile is required*</small>
                                </div>
                                <div className="col-sm-6">
                                    <FancyInput name="mobile" type="tel" maxLength="20" label="Mobile Number" value={this.state.mobile} handleChange={this.handleInputChange.bind(this)} />
                                    <small>Phone or mobile is required*</small>
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-sm-6">
                                    <FancyInput name="company" maxLength="50" label="Company (optional)" value={this.state.company} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-6">
                                    <FancyInput name="abn" maxLength="11" label="ABN" value={this.state.abn} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                            </div>
                            <div className="row form-row custom-fields">
                                <div className="col-sm-6">
                                    <FancyToggle
                                        title="Are you GST registered?"
                                        name="gst_registered"
                                        setValue={this.setGstValue.bind(this)}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <FancySelect
                                        title="I'm interested in becoming a:"
                                        list={[
                                            'Wholesale partner',
                                            'Channel partner',
                                            'Exetel reseller',
											'Exetel recommender',
                                            'I\'m unsure'
                                        ]}
                                        setValue={this.setInterestedValue.bind(this)}
                                    />
                                </div>
                            </div>
							<Errors errors={this.state.errors} />
                            <div className="row centered form-row button-row">
                                <div className="col-xs-12">
                                    <Button
                                        action={event => this.handleSubmit(event)}
                                        image="/images/btn-submit-darkgreen.svg"
                                        alt="Lets get started"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
					<Success animate={this.state.animateSuccess} />
					<Loader whiteBg={true} />
                </div>
            </div>
        );
    }

}

export default PartnersForm;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/PartnersForm/PartnersForm.js